import { Label, RadioControl } from './RadioButton.styles';
import type { RadioButtonProps } from './RadioButton.types';

export function RadioButton({
  name,
  value,
  label,
  checked,
  onChange,
  disabled,
  error,
  variant = 'default',
}: RadioButtonProps) {
  return (
    <Label data-disabled={disabled} data-variant={variant} data-selected={checked}>
      <RadioControl
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        disabled={disabled}
        data-error={error}
        aria-invalid={error}
      />
      {label}
    </Label>
  );
}
